/**
 * Habilidade de cada posição (GDD, seção 5; item 4.4): uma por atleta, tecla E ou botão Y, com recarga de
 * MATCH.abilityCooldownSeconds.
 */
import type { Position } from "./rules.js";

export const ABILITIES = {
  /** Artilheiro: drible em espiral para o lado; imune a Petardo e a roubo enquanto dura. */
  finta: {
    seconds: 0.5,
    /** Impulso para o lado (m/s), que o Controle corta aos poucos. */
    sideSpeed: 11,
  },
  /** Goleiro: aumenta a área de defesa do aro. */
  muralha: {
    seconds: 2,
    /** Alcance do soco e da pegada multiplicados por isto. */
    reachFactor: 2,
  },
  /** Batedor: redireciona os dois Petardos de uma vez, se estiverem neste alcance (m). */
  rebatidaDupla: {
    reach: 9,
  },
  /** Caçador: arrancada em queda; mão mais longa, mas bater no chão rápido demais atordoa. */
  mergulho: {
    seconds: 1,
    /** Velocidade para a frente e para baixo no início do mergulho (m/s). */
    forwardSpeed: 26,
    downSpeed: 9,
    catchReachFactor: 1.6,
    /** Chegar ao chão mais rápido que isto (m/s, na vertical) durante o mergulho é queda: atordoa. */
    crashSpeed: 5,
    crashStunSeconds: 1.5,
  },
} as const;

export type AbilityId = keyof typeof ABILITIES;

export const ABILITY_OF: Record<Position, AbilityId> = {
  artilheiro: "finta",
  goleiro: "muralha",
  batedor: "rebatidaDupla",
  cacador: "mergulho",
};

export const ABILITY_LABELS: Record<AbilityId, { name: string; hint: string }> = {
  finta: { name: "Finta Espiral", hint: "drible para o lado, imune a Petardo por 0,5 s" },
  muralha: { name: "Muralha", hint: "área de defesa do aro maior por 2 s" },
  rebatidaDupla: { name: "Rebatida Dupla", hint: "rebate os dois Petardos de uma vez" },
  mergulho: { name: "Mergulho", hint: "arrancada em queda; cuidado com o chão" },
};
